import React from 'react';
type SectionHeadingProps = {
  eyebrow?: string;
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  align?: 'center' | 'left';
  as?: 'h2' | 'h3';
};
export function SectionHeading({
  eyebrow,
  title,
  subtitle,
  align = 'center',
  as = 'h2'
}: SectionHeadingProps) {
  const Tag = as;
  const alignment = align === 'center' ? 'text-center items-center mx-auto' : 'text-left items-start';
  return <div className={`flex max-w-3xl flex-col gap-4 ${alignment}`} data-id="element-214" data-mp="bk3qjsstbbc1">
      {eyebrow ? <span className="inline-flex items-center rounded-full border border-gold-500/40 bg-gold-500/10 px-4 py-1.5 text-xs font-bold uppercase tracking-[0.18em] text-gold-400" data-id="element-215" data-mp="gjzvbu9c36sn">
          {eyebrow}
        </span> : null}
      <Tag className="font-display text-3xl uppercase leading-[1.05] tracking-tight text-cream sm:text-4xl md:text-5xl" data-id="element-216" data-mp="6sc4nvklpts8">
        {title}
      </Tag>
      {subtitle ? <p className="text-base leading-relaxed text-cream/70 sm:text-lg" data-id="element-217" data-mp="zahf39c6us1v">{subtitle}</p> : null}
    </div>;
}